import { FunctionComponent } from 'react'
import { Link } from 'react-router-dom'

import goBackImg from '../../assets/icons/bt-voltar-cadastro.png'
import logoTmov from '../../assets/images/logoTmov.svg'
import { IPageProps } from './PageComponent.types'
import {
  Container,
  ContainerHeader,
  Logo,
  Icon,
  Title,
  ContainerBottom,
  ButtonGoBackStep,
} from './styles'

const Page: FunctionComponent<IPageProps> = ({
  icon,
  title,
  className,
  goBackTo,
  children,
}) => {
  return (
    <>
      <Container className={className}>
        <ContainerHeader>
          <Logo src={logoTmov} />
          {icon && <Icon src={icon} />}

          <Title
            dangerouslySetInnerHTML={{ __html: title }}
            haveIcon={!!icon}
          />
        </ContainerHeader>

        {children}

        <ContainerBottom>
          {goBackTo ? (
            <ButtonGoBackStep onClick={goBackTo}>
              <img src={goBackImg} alt="Voltar" width={60} height={75} />
            </ButtonGoBackStep>
          ) : (
            <Link to="/">
              <img src={goBackImg} alt="Voltar" width={60} height={75} />
            </Link>
          )}
        </ContainerBottom>
      </Container>
    </>
  )
}

export default Page
